var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIconBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0012 5.70977L10.6682 1.56177C10.2002 1.19768 9.6242 1 9.03125 1C8.43829 1 7.86226 1.19768 7.39425 1.56177L2.06025 5.70977C1.73969 5.95905 1.48034 6.2783 1.30201 6.64312C1.12367 7.00794 1.03106 7.40869 1.03125 7.81477V15.0148C1.03125 15.5452 1.24196 16.0539 1.61704 16.429C1.99211 16.8041 2.50082 17.0148 3.03125 17.0148H15.0312C15.5617 17.0148 16.0704 16.8041 16.4455 16.429C16.8205 16.0539 17.0312 15.5452 17.0312 15.0148V7.81477C17.0312 6.99177 16.6512 6.21477 16.0012 5.70977Z",
    stroke: "#06097D",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12C10.79 13.333 7.208 13.333 5 12",
    stroke: "#0E119C",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconBlue);
export default __webpack_public_path__ + "static/media/home-icon-blue.6d35444ff9da981c20a3e62de8310fdd.svg";
export { ForwardRef as ReactComponent };